import "./MoodOverviewPage.css";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { apiRequest } from "services/apiRequest";
import { requestType } from "services/requests";

import Navbar from "components/Navbar/Navbar";
import SearchIcon from "assets/images/search-icon.png";
import DefaultIcon from "assets/images/icons 1.png";
import useDebounce from "utilities/hook/useDebounce";
import Loader from "utilities/reusableComponent/Loader/Loader";

function MoodeOverviewPage() {
  const navigate = useNavigate();
  // get user token from global state
  const { userInfo } = useSelector((state) => state.auth);
  const { openMenu } = useSelector((state) => state.menu);

  const [search, setSearch] = useState('');
  const [moodOverviews, setMoodOverviews] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleSearchStudent = async() => {
    setLoading(true);
    const response = await apiRequest({
      requestType: requestType.getTeacherStudent,
      payload: {
        data: {
          "user_uid": userInfo?.uid,
          "name": search,
        }
      },
    });
    if (response?.data?.status === 0) {
        const originalData = await(response.data.data);
        const moodStudent = originalData.map(function(item) {
          return {
            'uid' : item.uid,
            'first_name' : `${item?.child_details?.first_name}`,
            'last_name' : `${item?.child_details?.last_name}`,
            'image_url' : item?.child_details.child_avatar_details?.image_url,
          }
        });
        setLoading(false);
        setMoodOverviews(moodStudent);
    } else {
      setLoading(false);
    }
  }

  useDebounce(() => {
      handleSearchStudent();
    },[search],300
  );

  const handleOnClickStudent = (user) => {
    navigate(`/mood-overview/${user.uid}-${user.first_name.toLowerCase()}-${user.last_name.toLowerCase()}`);
  }

  return (
    <div className="">
      <Navbar />
      <div className="max-w-screen-lg mx-auto">
        <div className="pt-[50px] pb-[150px] w-full">
          <h1 className="font-gluten text-custom-navy font-bold text-4xl">
            Mood Overview
          </h1>

          <div className="w-full items-center">
            <div>
            <input
              type="text"
              onChange={(event) => {
                setSearch(event.target.value)
              }}
              placeholder="Find Student Name ..."
              className="rounded-[99px] w-full h-[66px] box-border my-[30px] pl-8 py-[10px] bg-[#f6f6f6] border border-[#e8e8e8] text-[22px] text-form-color placeholder:text-form-placeholder-color"
            />
            </div>
            {!openMenu && (
              <div className="relative float-right w-[36px] h-[36px] bg mt-[-80px] mr-[20px] cursor-pointer" onClick={handleSearchStudent}> 
                <img
                  src={SearchIcon}
                  className="w-[36px] h-[36px] flex-shrink-0"
                  alt=""
                />
              </div>
            )}
          </div>

          <div className="text-2xl font-bold mb-8">
            <h1>My Students</h1>
          </div>

          <div className="grid grid-cols-7 gap-2">
            {moodOverviews.map((item, index) => {
              return (
                <div
                  key={index}
                  className="p-[5px] flex items-start justify-center cursor-pointer"
                  onClick={() => handleOnClickStudent(item)}
                >
                  <div className="mb-2">
                    <div className="flex justify-center">
                      <div className="w-[75px] h-[75px] rounded-full border-[3px] border-custom-navy overflow-hidden flex-shrink-0">
                        <img
                          src={item.image_url !== undefined ? item.image_url : DefaultIcon}
                          className="w-full h-full object-contain"
                          alt=""
                        />
                      </div>
                    </div>  
                    <div>
                      <h4 className="text-black">
                        {item.first_name} {item.last_name}
                      </h4>
                    </div>
                  </div>  
                </div>
              );
            })}
          </div>
        </div>
      </div>
      {loading && <Loader />}
    </div>
  );
}

export default MoodeOverviewPage;
